<template>
  <StagingBanner />
  <router-view />
  <AppOverlay />
  <ToastContainer />
</template>

<script setup lang="ts">
import { nextTick, onMounted } from 'vue'
import { useStore } from 'vuex'
import { Mutations } from '@/store/enums/StoreEnums'
import { initializeComponents } from '@/core/plugins/keenthemes'
import AppOverlay from '@/components/feedback/AppOverlay.vue'
import ToastContainer from '@/components/feedback/ToastContainer.vue'
import StagingBanner from '@/components/StagingBanner.vue'

const store = useStore()

onMounted(() => {
  // Override layout config using saved data from localStorage.
  // Remove to use config only from static config (@/core/config/DefaultLayoutConfig.ts).
  store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG)

  void nextTick(() => {
    initializeComponents()
  })
})
</script>

<style lang="scss">
@import '~bootstrap-icons/font/bootstrap-icons.css';
@import '~apexcharts/dist/apexcharts.css';
@import '~quill/dist/quill.snow.css';
@import '~animate.css';
@import '~sweetalert2/dist/sweetalert2.css';
@import '~nouislider/dist/nouislider.css';
@import '~@fortawesome/fontawesome-free/css/all.min.css';
@import '~socicon/css/socicon.css';
@import '~line-awesome/dist/line-awesome/css/line-awesome.css';
@import '~dropzone/dist/dropzone.css';
@import '~@vueform/multiselect/themes/default.css';
@import '~prism-themes/themes/prism-shades-of-purple.css';
@import '~element-plus/dist/index.css';

// Main demo style scss
@import 'assets/sass/plugins';
@import 'assets/sass/style';

//RTL version styles
//@import "assets/css/style.rtl.css";
a {
  text-decoration: none;
}
i {
  font-size: 1.5em;
}
</style>
